export const RERUN_INDEX_WORKER_JOB_NAME = "rerun_index_worker_job" as const;

export const RERUN_INDEX_WORKER_JOB_DESC = `Triggers a one-time rerun for an Index Worker via the runIndexWorker mutation.

Use when the user explicitly asks to re-run/rerun an Index Worker job once.
Always confirm before executing because this is a write operation.

Input:
- 'indexWorkerId' (required): Index Worker ID (GraphQL global ID) to run once.
- 'projectId' (optional): Index Worker project ID. If omitted, the tool tries to derive it from indexWorkerId.

Output:
- 'indexWorkerId': The Index Worker ID that was triggered.
- 'projectId' / 'workspaceId': Resolved IDs used for navigation.
- 'projectPath' / 'detailPath': Relative paths to the IW project and IW detail pages.
- 'projectUrl' / 'detailUrl': Absolute URLs when frontend origin is available.
- 'rerunStarted': True when the rerun request succeeds.
- 'revalidatedTags': Cache tags revalidated during execution.

Response guidance:
- When 'detailUrl' exists, include it as a clickable link in the assistant reply so users can open the target page immediately.`;
